<div class="content-1920">
  <div class="content-padding margin-top-small">
    <h2>User Management</h2>
    <h5>Current Total Users: {{ users.length }}</h5>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Email</th>
          <th scope="col">Phone</th>
          <th scope="col">Address</th>
          <th scope="col">Status</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        @for (user of users; track user; let i = $index) {
        <tr>
          <td>
            <ngb-highlight [result]="user.fullname" term=""></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="user.email" term=""></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="user.phone" term=""></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="user.address" term=""></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="user.status" term=""></ngb-highlight>
          </td>
          @if (user.status == 'Disabled') {
          <td>
            <button
              class="btn-save"
              type="submit"
              (click)="enableUser(user.username)"
            >
              Enable
            </button>
          </td>
          } @if (user.status == 'Enabled') {
          <td>
            <button
              class="btn-save"
              type="submit"
              (click)="disableUser(user.username)"
            >
              Disable
            </button>
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
    <div class="fieldwrap fieldwrap-type-submit align-right">
      <a class="btn__secondary btn-back" routerLink="/home">Back</a>
    </div>
  </div>
</div>
